// extracted by mini-css-extract-plugin
module.exports = {"root":"FeatureIcons_root__54uOj","icons":"FeatureIcons_icons__N7BN_"};